import Vue from 'vue';
import {ValidationProvider, ValidationObserver, extend, configure} from 'vee-validate';

import {required, email, min, max} from 'vee-validate/dist/rules';

configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid',
  }
});

extend('required', {
  ...required,
  message: "The field is required",
});

extend('min', {
  ...min,
  message: "Too short ({length} min)"
});

extend('max', {
  ...max,
  message: "Too long ({length} max)"
});

extend('email', {
  ...email,
  message: "The field must be an email"
});

extend('student_email', {
  validate: value => value.endsWith('@uchicago.edu'),
  message: 'Your student email must be on @uchicago.edu domain'
});

extend('password', {
  params: ['target'],
  validate(value, {target}) {
    return value === target;
  },
  message: 'Password confirmation does not match'
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
